import ReactDOM from 'react-dom';
import 'assets/fonts/proxima-nova/index.css';
import './index.css';
import 'react-virtualized/styles.css';
import App from './App';

ReactDOM.render(App(), document.getElementById('root'));
